// extracted by mini-css-extract-plugin
export var skipAnimation = "_4g-0";